import { useCallback } from 'react'

import useSessionStorageState from 'use-session-storage-state'

export const useRecentPlatforms = () => {
  const [recentPlatforms, setRecentPlatforms] = useSessionStorageState<Record<string, string[] | undefined>>(
    'nw-recent-platforms',
    {
      defaultValue: {},
    },
  )

  const handleRecentPlatforms = useCallback(
    (props: { environmentId: string; platformId: string }) => {
      if (!!props.environmentId && !!props.platformId) {
        setRecentPlatforms((prev) => {
          const result = { ...prev }

          if (!(props.environmentId in result)) {
            result[props.environmentId] = []
          }

          if (!result[props.environmentId]!.includes(props.platformId)) {
            result[props.environmentId]!.unshift(props.platformId)
          } else {
            result[props.environmentId] = result[props.environmentId]!.filter((id) => id !== props.platformId)
          }

          if (result[props.environmentId]!.length > 3) {
            result[props.environmentId]!.pop()
          }

          return result
        })
      }
    },
    [setRecentPlatforms],
  )

  return [recentPlatforms, handleRecentPlatforms] as const
}
